import { CoreData } from '@carvana/merch-tile';
import TagId from '~/constants/srp/TagId';
import type { RecommendedVehicle } from '~/contracts/common';
import type { Vehicle } from '~/contracts/srp';

const requiredTagsIds = [TagId.EVCredit, TagId.GreatDeal, TagId.PriceDrop];

export default function someHaveAllDealTags(
  vehicles: Vehicle[] | RecommendedVehicle[] | CoreData[]
): boolean {
  return vehicles.some(v =>
    requiredTagsIds.every(id => v.vehicleTags.some(tag => tag.tagId === id))
  );
}
